import React from 'react';
import ReactDOM from 'react-dom/client';
import { SecureMessagesMapStyle, clientId } from './SecureMesage';
import '../assets/css/bootstrap.min.css';

import '../assets/css/style.css';
import '../assets/css/comon.css';
import '../assets/css/cssComm.css';
import '../assets/css/jquery-ui.min.css';
import '../assets/css/coverage.css';
import { ReactViewAdobe, previewFile } from 'react-adobe-embed';


export const  Root = () => {
    return(

 
 <div
    ui-view=""
    className=""
    style={{ backgroundColor: "rgb(238, 238, 238)" }}
  >
    <div id="aet-wrapper" className="aet-wrapper container-fluid navMobile" />
    <div className="mobileMenu"></div>
    <div className="entireWarpper">
      <div className="backDropMobMenu"></div>
      {/*<div ui-view="topchrome"></div>*/}
      {/**/}
      <div ui-view="topchromeNew">
        <div id="Qualtrics" style={{ height: 1 }} />
        <div id="aet-header" className="aet-header alternate-home-header">
          <div data-parent="0-header" id="topChromeNew_1" data-type="topChromeNew">
            <div
              className="container topChromeLogo padLeftClear padRightClear"
              data-parent="leftjustified_4"
              id="images_5"
              data-type="images"
              parentdata-type="leftjustified"
            >
              <div id="toFocus">
                <a id="toHoldFocus" tabIndex={-1}>
                  HoldFocus
                </a>
              </div>
              <div id="skip-to-content">
                <a id="skip-anchor" href="">
                  Skip to main content
                </a>
              </div>
              <div className="mobileHam" />
              <div className="originalTopChromeLinks">
                <div className="logout" />
                <ul
                  className="nav navbar-nav bottom_chrome_link"
                  style={{ visibility: "visible" }}
                  data-parent="rightjustified_19"
                  id="links_23"
                  data-type="links"
                  parentdata-type="rightjustified"
                  data-nvstyle="headerLinks"
                >
                  <li>
                    <a
                      data-parent="links_23"
                      id="headerMenuImage_24"
                      data-type="headerMenuImage"
                      parentdata-type="links"
                      data-nvstyle="headerLinks"
                      title="Home"
                      className="home-util"
                      ng-class="{'linkActiveUnderline': flagForUnderline=='Home'}"
                      href="#/contentPage?page=homePageNew"
                    >
                      <div className="pad0 floatMeLeft">
                        <img
                          data-parent="headerMenuImage_24"
                          id="image_27"
                          parentdata-type="headerMenuImage"
                          src="/aetna/aetna-press-center_files/white_home.png?v=yhbqd"
                          className="left-img"
                          alt=""
                        />
                      </div>
                      <span className="sr-only" id="srForHome">
                        Not Selected{" "}
                      </span>
                      Home
                    </a>
                  </li>
                  <li>
                    <a
                      data-parent="links_23"
                      id="headerMenuImage_32"
                      data-type="headerMenuImage"
                      parentdata-type="links"
                      data-nvstyle="headerLinks"
                      title="Messages"
                      ng-class="{'linkActiveUnderline': flagForUnderline=='Messages'}"
                      href="#/contentPage?page=messages"
                      className="linkActiveUnderline"
                      style={{}}
                    >
                      <span className="sr-only">Selected </span>Messages
                      <div className="left-block  col-xs-10 pad0">
                        <p className="menu-list-txt">
                          <span
                            data-parent="headerMenuImage_32"
                            id="textSpan_37"
                            data-type="textSpan"
                            parentdata-type="headerMenuImage"
                            data-nvstyle="badge"
                          />
                        </p>
                      </div>
                      <span
                        style={{ visibility: "visible" }}
                        className="myMessageCounter badge badge-important"
                      >
                        0
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      data-parent="links_23"
                      id="headerMenuImage_38"
                      data-type="headerMenuImage"
                      parentdata-type="links"
                      data-nvstyle="headerLinks"
                      title="Forms"
                      ng-class="{'linkActiveUnderline': flagForUnderline=='Forms'}"
                      href="#/contentPage?page=formsLib"
                    >
                      <span className="sr-only">Not Selected </span>Forms
                    </a>
                  </li>
                  <li>
                    <a
                      data-parent="links_23"
                      id="headerMenuImage_43"
                      data-type="headerMenuImage"
                      parentdata-type="links"
                      data-nvstyle="headerLinks"
                      title="Profile"
                      ng-class="{'linkActiveUnderline': flagForUnderline=='Profile'}"
                      href="#/contentPage?page=profile"
                    >
                      <span className="sr-only">Not Selected </span>Profile
                    </a>
                  </li>
                  <li>
                    <a
                      data-parent="links_23"
                      id="headerMenuImage_49"
                      data-type="headerMenuImage"
                      parentdata-type="links"
                      data-nvstyle="headerLinks"
                      title="Contact Us"
                      ng-class="{'linkDeactiveUnderline': flagForUnderline=='Contact Us'}"
                    >
                      <span className="sr-only">Not Selected </span>Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      data-parent="links_23"
                      id="headerMenuImage_55"
                      data-type="headerMenuImage"
                      parentdata-type="links"
                      data-nvstyle="headerLinks"
                      title="Log Out"
                      className="topChromeLogout"
                      style={{ marginLeft: 130 }}
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
              <div className="navbar navbar-default">
                <div className="menuButtonTopChrome">
                  <div>
                    <div id="mySidenav" className="sidenav">
                      <ul
                        role="navigation"
                        className="col-xs-12 menu-list pad0"
                        style={{ display: "none" }}
                        id="accessMenu"
                      >
                        <li className="inactive clearfix ng-scope">
                          <p tabIndex={0} className="col-xs-8 menu-txt">
                            Menu
                          </p>
                          <a
                            role="button"
                            aria-label="Close Menu"
                            className="close-menu col-xs-4"
                            href=""
                          />
                          <br />
                        </li>
                        <div className="unbindRedundantClick">
                          <li
                            className="home-mobile-list"
                            style={{ display: "none" }}
                          >
                            Welcome ZIPING LIU
                          </li>
                          <a
                            href="#/contentPage?page=homePageNew"
                            className="homeLinkOnMenu"
                          >
                            Home
                          </a>{" "}
                        </div>
                        <li
                          role="menuitem"
                          className="col-xs-12 home_group pad0 ng-scope"
                        >
                          <a
                            data-parent="primaryMenu_79"
                            id="link_80"
                            data-parentdata-type="primaryMenu"
                            data-nvstyle="canbActive"
                            className="center-block pad0 col-xs-12 mobileClick"
                            href="#/contentPage?page=providerSearch"
                          >
                            <div className="col-xs-2 pad0">
                              <img
                                data-parent="link_80"
                                id="image_81"
                                src="/aetna/aetna-press-center_files/ineed_care.png?v=yhbqd"
                                className="left-img"
                                alt=""
                              />
                            </div>
                            <div className="left-block col-xs-10 pad0">
                              <p className="menu-list-txt">
                                <span
                                  data-parent="link_24"
                                  id="textSpan_28"
                                  data-type="textSpan"
                                  className="ng-scope"
                                >
                                  Find Care
                                </span>
                              </p>
                            </div>
                            <span className="home-mobile-list home-down-arrow" />
                          </a>
                          <div
                            data-parent="link_80"
                            id="secondaryTabMenu_87"
                            data-type="secondaryTabMenu"
                            data-nvstyle="canbActive"
                            className="col-xs-11 nested-list"
                            style={{ display: "none" }}
                          >
                            <a
                              data-parent="secondaryTabMenu_87"
                              id="link_88"
                              parentdata-type="secondaryTabMenu"
                              className="ng-scope center-block pad0 col-xs-12 subMenuMobiView"
                              href="#/contentPage?page=providerSearch"
                              title="My Providers & Visits"
                            >
                              My Providers &amp; Visits
                              <img
                                data-parent="link_88"
                                id="nextImgBtn_92"
                                data-type="nextImgBtn"
                                src="/aetna/aetna-press-center_files/next.png?v=yhbqd"
                                alt=""
                              />
                            </a>
                          </div>
                        </li>
                        <li
                          role="menuitem"
                          className="col-xs-12 home_group pad0 ng-scope"
                        >
                          <a
                            data-parent="primaryMenu_79"
                            id="link_98"
                            parentdata-type="primaryMenu"
                            data-nvstyle="blueActive"
                            className="center-block pad0 col-xs-12 mobileClick"
                            role="link"
                            href="#/contentPage?page=claimListing"
                          >
                            <div className="col-xs-2 pad0">
                              <img
                                data-parent="link_98"
                                id="image_99"
                                src="/aetna/aetna-press-center_files/manage_my_claims.png?v=yhbqd"
                                className="left-img"
                                alt=""
                              />
                            </div>
                            <div className="left-block col-xs-10 pad0">
                              <p className="menu-list-txt">
                                <span
                                  data-parent="link_24"
                                  id="textSpan_28"
                                  data-type="textSpan"
                                  className="ng-scope"
                                >
                                  Manage Claims
                                </span>
                              </p>
                            </div>
                            <span className="home-mobile-list home-down-arrow" />
                          </a>
                          <div
                            data-parent="link_98"
                            id="secondaryTabMenu_105"
                            data-type="secondaryTabMenu"
                            data-nvstyle="blueActive"
                            className="col-xs-11 nested-list"
                            style={{ display: "none" }}
                          >
                            <a
                              data-parent="secondaryTabMenu_105"
                              id="link_106"
                              parentdata-type="secondaryTabMenu"
                              className="ng-scope center-block pad0 col-xs-12 subMenuMobiView"
                              href="#/contentPage?page=claimListing"
                              title="Claims"
                            >
                              Claims
                            </a>
                            <div
                              data-parent="link_106"
                              id="teritaryTabMenu_111"
                              data-type="teritaryTabMenu"
                            >
                              <a
                                data-parent="secondaryTabMenu_105"
                                id="link_106"
                                parentdata-type="secondaryTabMenu"
                                className="ng-scope center-block pad0 col-xs-12 subMenuMobiView"
                                href="#/contentPage?page=claimListing"
                                title="Claims"
                              />
                              <a
                                data-parent="teritaryTabMenu_111"
                                id="link_112"
                                parentdata-type="teritaryTabMenu"
                                href="#/contentPage?page=claimDetails"
                                title="Claims Detail"
                                style={{ display: "none" }}
                              >
                                Claims Detail
                              </a>
                              <div
                                data-parent="link_112"
                                id="teritaryTabMenu_117"
                                data-type="teritaryTabMenu"
                              >
                                <a
                                  data-parent="teritaryTabMenu_111"
                                  id="link_112"
                                  parentdata-type="teritaryTabMenu"
                                  href="#/contentPage?page=claimDetails"
                                  title="Claims Detail"
                                  style={{ display: "none" }}
                                />
                                <a
                                  data-parent="teritaryTabMenu_117"
                                  id="link_118"
                                  parentdata-type="teritaryTabMenu"
                                  href="#/contentPage?page=claimsPaymentInfo"
                                  title="Claims Payment"
                                  style={{ display: "none" }}
                                >
                                  Claims Payment
                                </a>
                              </div>
                              <a
                                data-parent="teritaryTabMenu_111"
                                id="link_123"
                                parentdata-type="teritaryTabMenu"
                                href="#/contentPage?page=pharmacyClaimDetails"
                                title="Claims Detail"
                                style={{ display: "none" }}
                              >
                                Claims Detail
                              </a>
                            </div>
                            <a
                              data-parent="secondaryTabMenu_105"
                              id="link_128"
                              parentdata-type="secondaryTabMenu"
                              className="ng-scope center-block pad0 col-xs-12 subMenuMobiView"
                              href="#/contentPage?page=eobList"
                              title="Explanation of Benefits"
                            >
                              Explanation of Benefits
                            </a>
                            <div
                              data-parent="link_128"
                              id="teritaryTabMenu_133"
                              data-type="teritaryTabMenu"
                            >
                              <a
                                data-parent="secondaryTabMenu_105"
                                id="link_128"
                                parentdata-type="secondaryTabMenu"
                                className="ng-scope center-block pad0 col-xs-12 subMenuMobiView"
                                href="#/contentPage?page=eobList"
                                title="Explanation of Benefits"
                              />
                              <a
                                data-parent="teritaryTabMenu_133"
                                id="link_134"
                                parentdata-type="teritaryTabMenu"
                                href="#/contentPage?page=eobDetail"
                                title="Explanation of Benefits Detail"
                                style={{ display: "none" }}
                              >
                                Explanation of Benefits Detail
                              </a>
                            </div>
                          </div>
                        </li>
                        <li
                          role="menuitem"
                          className="col-xs-12 home_group pad0 ng-scope"
                        >
                          <a
                            data-parent="primaryMenu_79"
                            id="link_141"
                            parentdata-type="primaryMenu"
                            data-nvstyle="purpleActive"
                            className="center-block pad0 col-xs-12 mobileClick"
                            role="link"
                            href="#/contentPage?page=coverageBenefits"
                          >
                            <div className="col-xs-2 pad0">
                              <img
                                data-parent="link_141"
                                id="image_142"
                                src="/aetna/aetna-press-center_files/coverage.png?v=yhbqd"
                                className="left-img"
                                alt=""
                              />
                            </div>
                            <div className="left-block col-xs-10 pad0">
                              <p className="menu-list-txt">
                                <span
                                  data-parent="link_24"
                                  id="textSpan_28"
                                  data-type="textSpan"
                                  className="ng-scope"
                                >
                                  See Coverage &amp; Benefits
                                </span>
                              </p>
                            </div>
                            <span className="home-mobile-list home-down-arrow" />
                          </a>
                          <div
                            data-parent="link_141"
                            id="secondaryTabMenu_148"
                            data-type="secondaryTabMenu"
                            data-nvstyle="purpleActive"
                            className="col-xs-11 nested-list"
                            style={{ display: "none" }}
                          >
                            <a
                              data-parent="secondaryTabMenu_148"
                              id="link_149"
                              parentdata-type="secondaryTabMenu"
                              className="ng-scope center-block pad0 col-xs-12 subMenuMobiView"
                              href="#/contentPage?page=coverageBenefits"
                              title="Coverage & Benefits"
                            >
                              Coverage &amp; Benefits
                            </a>
                          </div>
                        </li>
                        <li
                          role="menuitem"
                          className="col-xs-12 home_group pad0 ng-scope"
                        >
                          <a
                            data-parent="primaryMenu_79"
                            id="link_154"
                            parentdata-type="primaryMenu"
                            data-nvstyle="greenActive"
                            className="center-block pad0 col-xs-12 mobileClick"
                            role="link"
                            href="#/contentPage?page=wellnessHome"
                          >
                            <div className="col-xs-2 pad0">
                              <img
                                data-parent="link_154"
                                id="image_155"
                                src="/aetna/aetna-press-center_files/stay_healthy_new.png?v=yhbqd"
                                className="left-img"
                                alt=""
                              />
                            </div>
                            <div className="left-block col-xs-10 pad0">
                              <p className="menu-list-txt">
                                <span
                                  data-parent="link_24"
                                  id="textSpan_28"
                                  data-type="textSpan"
                                  className="ng-scope"
                                >
                                  Stay Healthy
                                </span>
                              </p>
                            </div>
                            <span className="home-mobile-list home-down-arrow" />
                          </a>
                          <div
                            data-parent="link_154"
                            id="secondaryTabMenu_161"
                            data-type="secondaryTabMenu"
                            data-nvstyle="greenActive"
                            className="col-xs-11 nested-list"
                            style={{ display: "none" }}
                          >
                            <a
                              data-parent="secondaryTabMenu_161"
                              id="link_162"
                              parentdata-type="secondaryTabMenu"
                              className="ng-scope center-block pad0 col-xs-12 subMenuMobiView"
                              href="#/contentPage?page=wellnessHome"
                              title="Health Programs"
                            >
                              Health Programs
                            </a>
                            <div
                              data-parent="link_162"
                              id="teritaryTabMenu_167"
                              data-type="teritaryTabMenu"
                            >
                              <a
                                data-parent="secondaryTabMenu_161"
                                id="link_162"
                                parentdata-type="secondaryTabMenu"
                                className="ng-scope center-block pad0 col-xs-12 subMenuMobiView"
                                href="#/contentPage?page=wellnessHome"
                                title="Health Programs"
                              />
                              <a
                                data-parent="teritaryTabMenu_167"
                                id="link_168"
                                parentdata-type="teritaryTabMenu"
                                href="#/contentPage?page=wellnessHome"
                                title="Breast Health Survey"
                                style={{ display: "none" }}
                              >
                                Breast Health Survey
                              </a>
                              <a
                                data-parent="teritaryTabMenu_167"
                                id="link_173"
                                parentdata-type="teritaryTabMenu"
                                href="#/contentPage?page=wellnessHome"
                                title="Breast Health Survey Confirmation"
                                style={{ display: "none" }}
                              >
                                Breast Health Survey Confirmation
                              </a>
                            </div>
                          </div>
                        </li>
                        <li
                          className="col-xs-12 pad0 home-mobile-list ng-scope"
                          data-parent="primaryMenu_79"
                          id="mobileMenuList_195"
                          data-type="mobileMenuList"
                          parentdata-type="primaryMenu"
                        >
                          <ul className="mobile-list-new">
                            <li role="menuitem">
                              <a
                                data-parent="mobileMenuList_195"
                                id="headerMenuImage_196"
                                data-type="headerMenuImage"
                                parentdata-type="mobileMenuList"
                                className="mobileMenuList"
                                title="Messages"
                                href="#/contentPage?page=messages"
                              >
                                <img
                                  data-parent="headerMenuImage_196"
                                  id="image_199"
                                  parentdata-type="headerMenuImage"
                                  src="https://member.aetna.com/secure/member/images/utility/messages-top.png?v=yhbqd"
                                  alt=""
                                />
                                Messages
                                <span
                                  style={{ visibility: "visible" }}
                                  className="myMessageCounter badge badge-important"
                                >
                                  10
                                </span>
                                <span
                                  data-parent="headerMenuImage_196"
                                  id="textSpan_203"
                                  data-type="textSpan"
                                  parentdata-type="headerMenuImage"
                                  data-nvstyle="badge"
                                />
                              </a>
                            </li>
                            <li role="menuitem">
                              <a
                                data-parent="mobileMenuList_195"
                                id="headerMenuImage_204"
                                data-type="headerMenuImage"
                                parentdata-type="mobileMenuList"
                                className="mobileMenuList"
                                title="Forms"
                                href="#/contentPage?page=formsLib"
                              >
                                <img
                                  data-parent="headerMenuImage_204"
                                  id="image_207"
                                  parentdata-type="headerMenuImage"
                                  src="/aetna/aetna-press-center_files/utility/forms-top.png?v=yhbqd"
                                  alt=""
                                />
                                Forms
                              </a>
                            </li>
                            <li role="menuitem">
                              <a
                                data-parent="mobileMenuList_195"
                                id="headerMenuImage_211"
                                data-type="headerMenuImage"
                                parentdata-type="mobileMenuList"
                                className="mobileMenuList"
                                title="Profile"
                                href="#/contentPage?page=profile"
                              >
                                <img
                                  data-parent="headerMenuImage_211"
                                  id="image_214"
                                  parentdata-type="headerMenuImage"
                                  src="https://member.aetna.com/secure/member/images/utility/profile-top.png?v=yhbqd"
                                  alt=""
                                />
                                Profile
                              </a>
                            </li>
                            <li role="menuitem">
                              <a
                                data-parent="mobileMenuList_195"
                                id="headerMenuImage_219"
                                data-type="headerMenuImage"
                                parentdata-type="mobileMenuList"
                                className="mobileMenuList"
                                title="Contact Us"
                                href="mailto:aetnasiu@aetna.com"
                              >
                                <img
                                  data-parent="headerMenuImage_219"
                                  id="image_222"
                                  parentdata-type="headerMenuImage"
                                  src="https://member.aetna.com/secure/member/images/utility/contact-us-top.png?v=yhbqd"
                                  alt=""
                                />
                                Contact Us
                              </a>
                            </li>
                            <li role="menuitem">
                              <a
                                data-parent="mobileMenuList_195"
                                id="headerMenuImage_227"
                                data-type="headerMenuImage"
                                parentdata-type="mobileMenuList"
                                className="mobileMenuList"
                                title="Log Out"
                                href="#/logout"
                              >
                                <img
                                  data-parent="headerMenuImage_227"
                                  id="image_230"
                                  parentdata-type="headerMenuImage"
                                  src="https://member.aetna.com/secure/member/images/utility/logout-top.png?v=yhbqd"
                                  alt=""
                                />
                                Log Out
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <div
                      className="navbar-header col-xs-12 col-sm-3 pad0 pull-left aetLogoMargin"
                      id="adjustPSLogo"
                    >
                      <div className="navigator-logos pull-left"
              
                      >
                        <a
                          href="https://awsuni.com"
                          className="aet-logo"
                          title="Aetna Logo"
                        >
                          <img
                            data-parent="images_5"
                            id="image_6"
                            parentdata-type="images"
                            src="https://member.aetna.com/appConfig/login/images/aetna-logo.png?v=yhbqd"
                            alt="Aetna Home Page"
                          />&nbsp;
                          &nbsp;
              
                        </a>
                      </div>
                      <ul
                        className="nav-mobile-list pull-right"
                        data-parent="leftjustified_4"
                        id="links_9"
                        data-type="links"
                        parentdata-type="leftjustified"
                        data-nvstyle="headerMenu"
                      >
                        <li>
                          <a
                            data-parent="links_9"
                            id="headerMenuImage_10"
                            data-data-functionname="menuToggleBtn"
                            data-type="headerMenuImage"
                            parentdata-type="links"
                            data-nvstyle="headerMenu"
                            title="Messages"
                            href="#/contentPage?page=messages"
                          >
                            <div className="pad0">
                              <img
                                data-parent="headerMenuImage_10"
                                id="image_14"
                                parentdata-type="headerMenuImage"
                                src="/aetna/aetna-press-center_files/utility/messages-top-mobile.png?v=yhbqd"
                                className="left-img"
                                alt=""
                              />
                            </div>
                            <span className="nav-list-blk">Messages</span>
                            <span
                              style={{ visibility: "visible" }}
                              className="myMessageCounter badge badge-important"
                            >
                              0
                            </span>
                            <div className="left-block  col-xs-10 pad0 home-mobile-list home-down-arrow">
                              <p className="menu-list-txt" />
                              <div
                                data-parent="headerMenuImage_10"
                                id="text_18"
                                parentdata-type="headerMenuImage"
                                data-nvstyle="badge"
                              />
                              <p />
                            </div>
                          </a>
                        </li>
                      </ul>
                      <br />
                      <div className="divMenuTopChrome">
                        <div
                          className="menuTopChrome"
                          style={{ fontWeight: "normal" }}
                        >
                          <a
                            className="menuLinkTopChrome"
                            href="https://awsuni.com"
                            title="Home"
                          >
                            Home
                          </a>
                          <div />
                        </div>
                        <div
                          className="menuTopChrome"
                          style={{ fontWeight: "normal" }}
                        >
                          <a
                            className="menuLinkTopChrome"
                            href="https://awsuni.com/category/amazon-retaliatory-campaign"
                            title="Manage Claims"
                          >
                            Manage Claims
                          </a>
                          <div />
                        </div>
                        <div
                          className="menuTopChrome"
                          style={{ fontWeight: "normal" }}
                        >
                          <a
                            className="menuLinkTopChrome"
                            href="#/contentPage?page=coverageBenefits"
                            title="See Coverage & Benefits"
                          >
                            See Coverage &amp; Benefits
                          </a>
                          <div />
                        </div>
                        <div
                          className="menuTopChrome"
                          style={{ borderRight: "none", fontWeight: "normal" }}
                        >
                          <a
                            className="menuLinkTopChrome"
                            href="#/contentPage?page=wellnessHome"
                            title="Stay Healthy"
                          >
                            Stay Healthy
                          </a>
                          <div />
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    role="button"
                    className="menu-button"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="accessMenu"
                  >
                    <img
                      src="/aetna/aetna-press-center_files/menu_icon_desktop_transparent.png"
                      alt="Menu"
                    />
                  </button>
                </div>
                <div
                  data-parent="topChromeNew_1"
                  id="rightjustified_19"
                  data-type="rightjustified"
                  parentdata-type="topChromeNew"
                  className="pull-right navbar-collapse collapse col-sm-9 pad0"
                >
                  <ul
                    className="nav navbar-nav top_chrome_link"
                    data-parent="rightjustified_19"
                    id="links_20"
                    data-type="links"
                    parentdata-type="rightjustified"
                    data-nvstyle="headerLink"
                  >
                    <li>
                      <span className="top_welcome_link">
                        <img src="/aetna/aetna-press-center_files/user_black_icon.png" alt="" />
                        Welcome ZIPING LIU
                      </span>
                    </li>
                  </ul>
                  <div
                    data-parent="rightjustified_19"
                    id="links_59"
                    data-type="links"
                    parentdata-type="rightjustified"
                    data-nvstyle="headerMenuLinks"
                  >
                    <a data-parent="links_59" id="link_60" parentdata-type="links" />
                    <a data-parent="links_59" id="link_64" parentdata-type="links" />
                    <a data-parent="links_59" id="link_68" parentdata-type="links" />
                    <a data-parent="links_59" id="link_72" parentdata-type="links" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*<div ui-view="menu"></div>*/}
      <section className="">
        <div className="aet-template">
          {/**/}
          <div ui-view="newMenu">
            {/*   <link href="css/profile/common_mod.css?v=yhbqd&" rel="stylesheet"> */}
            <div
              id="aet-newMenu"
              className="aet-content-header gryblue-header"
              style={{ display: "block" }}
            >
              <div data-parent="0-menu" id="newNavigation_76" data-type="newNavigation">
                <div
                  className="container clearfix"
                  data-parent="newNavigation_76"
                  id="primaryMenu_79"
                  data-type="primaryMenu"
                  parentdata-type="newNavigation"
                >
                  <div
                    className="col-md-1 aet-content-hdrtxt pad0"
                    id="aet-content-hdrtxtone"
                  />
                  <div
                    data-parent="primaryMenu_79"
                    id="navText_178"
                    data-type="navText"
                    parentdata-type="primaryMenu"
                    className="col-md-5 col-xs-9 aet-content-hdrtxt pad0"
                  >
                    <div className="line-seperator" />
                    <h1
                      className="aet-cont-hdrtxt commonMarker ng-scope"
                      style={{ display: "inline-block" }}
                    >
                      Message Center
                    </h1>
                    <h1
                      className="aet-cont-hdrtxt canbActiveMarker"
                      style={{ display: "none" }}
                    >
                      <img
                        data-parent="navText_178"
                        id="image_179"
                        parentdata-type="navText"
                        data-nvstyle="canbActive"
                        src="/aetna/aetna-press-center_files/homeicons/findcare_icon_transparent.png?v=yhbqd"
                        alt=""
                      />
                      Find Care
                    </h1>
                    <h1
                      className="aet-cont-hdrtxt blueActiveMarker"
                      style={{ display: "none" }}
                    >
                      <img
                        data-parent="navText_178"
                        id="image_183"
                        parentdata-type="navText"
                        data-nvstyle="blueActive"
                        src="/aetna/aetna-press-center_files/homeicons/claims_icon_transparent.png?v=yhbqd"
                        alt=""
                      />
                      Manage Claims
                    </h1>
                    <h1
                      className="aet-cont-hdrtxt purpleActiveMarker"
                      style={{ display: "none" }}
                    >
                      <img
                        data-parent="navText_178"
                        id="image_187"
                        parentdata-type="navText"
                        data-nvstyle="purpleActive"
                        src="/aetna/aetna-press-center_files/homeicons/coverage_icon_transparent.png?v=yhbqd"
                        alt=""
                      />
                      See Coverage &amp; Benefits
                    </h1>
                    <h1
                      className="aet-cont-hdrtxt greenActiveMarker"
                      style={{ display: "none" }}
                    >
                      <img
                        data-parent="navText_178"
                        id="image_191"
                        parentdata-type="navText"
                        data-nvstyle="greenActive"
                        src="/aetna/aetna-press-center_files/homeicons/stayhealthy_icon_transparent.png?v=yhbqd"
                        alt=""
                      />
                      Stay Healthy
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="second-navigation"
              style={{ height: "auto !important", display: "none" }}
            >
              {/*removing role role="tablist" for WCAG observation*/}
              <div
                className="container clearfix"
                style={{ marginBottom: "-8px" }}
              >
                <a
                  data-parent="secondaryTabMenu_87"
                  id="link_88"
                  parentdata-type="secondaryTabMenu"
                  className="canbActiveMarker"
                  style={{ display: "none" }}
                  href="#/contentPage?page=healthHistory"
                  title="My Providers & Visits"
                >
                  My Providers &amp; Visits
                </a>
                <a
                  data-parent="secondaryTabMenu_105"
                  id="link_106"
                  parentdata-type="secondaryTabMenu"
                  className="blueActiveMarker borderLeftGrey sec-level-nav blueLevel"
                  style={{ display: "none" }}
                  href="#/contentPage?page=claimListing"
                  title="Claims"
                >
                  Claims
                </a>
                <a
                  data-parent="secondaryTabMenu_105"
                  id="link_128"
                  parentdata-type="secondaryTabMenu"
                  className="blueActiveMarker sec-level-nav mobile-level-nav"
                  style={{ display: "none" }}
                  href="#/contentPage?page=eobList"
                  title="Explanation of Benefits"
                >
                  Explanation of Benefits
                </a>
                <a
                  data-parent="secondaryTabMenu_148"
                  id="link_149"
                  parentdata-type="secondaryTabMenu"
                  className="purpleActiveMarker"
                  style={{ display: "none" }}
                  href="#/contentPage?page=coverageBenefits"
                  title="Coverage & Benefits"
                >
                  Coverage &amp; Benefits
                </a>
                <a
                  data-parent="secondaryTabMenu_161"
                  id="link_162"
                  parentdata-type="secondaryTabMenu"
                  className="greenActiveMarker"
                  style={{ display: "none" }}
                  href="#/contentPage?page=wellnessHome"
                  title="Health Programs"
                >
                  Health Programs
                </a>
              </div>
            </div>
            {/*start: code for second level navigation scroll in mobile  */}
            <div className="second-navigation-controller scroll-arrowsLR ">
              <span tabIndex={0}>
                {/*Added image to remove from CSS -WCAG observation*/}
                <img
                  tabIndex={0}
                  className="left-scrollarrow"
                  src="/aetna/aetna-press-center_files/claimsArrow_left.png"
                  alt="Tab scroll left"
                  style={{ visibility: "hidden" }}
                />
              </span>
              <span tabIndex={0}>
                {/*Added image to remove from CSS -WCAG observation*/}
                <img
                  tabIndex={0}
                  className="right-scrollarrow"
                  src="/aetna/aetna-press-center_files/claimsArrow.png"
                  alt="Tab scroll right"
                  style={{ visibility: "hidden" }}
                />
              </span>
            </div>
            {/*end: code for second level navigation scroll in mobile  */}{" "}
            {/**/}
          </div>
          {/**/}
          <div ui-view="content">
            {" "}
            {/**/}
            <div ui-view="centercontent">
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              {/**/}
              <div id="centerContentPagetitle-div">
                <div id="c-main-content" tabIndex={-1}>
                  <span className="sr-only">Main Content Start</span>
                </div>
                <div
                  data-parent="page_286"
                  id="pageTitle_291"
                  data-type="pageTitle"
                  parentdata-type="page"
                  className="aet-content-header clearfix"
                  style={{ display: "block" }}
                >
                  <div
                    className="aet-content-fluid pageTitleDiv"
                    style={{ display: "none" }}
                  >
                    {" "}
                    <div className="pull-left">
                      <h1 className="aet-cont-hdrtxt">Message Center</h1>
                      <span className="aet-whitesld-arr" />
                    </div>
                  </div>
                </div>
              </div>
              {/* <link href="css/common/common.css?v=yhbqd&" rel="stylesheet" /> */}
              {/**/}
              {/**/}
              {/**/}
              <div
                ng-if="contentId.indexOf('homePage') == -1"
                className="coverageBenefits_bg"
                id="main-div"
                role="main"
              >
                <div
                  data-parent="0-center"
                  id="page_286"
                  data-type="page"
                  key="MSG_CENTER"
                >
                  <div
                    data-parent="page_286"
                    id="content_293"
                    data-type="content"
                    parentdata-type="page"
                    className="aet-content-fluid linkBlockStyle"
                  >
                    <div
                      data-parent="content_293"
                      id="paragraph_294"
                      data-type="paragraph"
                      parentdata-type="content"
                    >
                      <div
                        data-parent="paragraph_294"
                        id="appid_295"
                        data-functionname="webApplicationContent"
                        parentdata-type="paragraph"
                      >
                        {/**/}
                        <div
                          className="controller"
                          data-data-src="'components/messages/newMessages.html?v=yhbqd'"
                          ng-include=""
                          style={{}}
                        >
                          <link
                            href="css/messages/cssComm.css?v=yhbqd&"
                            rel="stylesheet"
                          />
                          <link
                            href="css/messages/print_css.css?v=yhbqd&"
                            media="print"
                            rel="stylesheet"
                          />
                          <form
                            name="replyForm"
                            noValidate={false}
                            style={{ marginTop: 1 }}
                            className="ng-pristine ng-valid"
                          >
                            <div
                              className="entireWarpper"
                              ng-init="msginit()"
                              ng-controller="MessagesControllerNew"
                            >
                      
                              <div id="communicationCenterView">
                                <section
                                  className="aet-main-container communication_center"
                                  id="communication_center"
                                  role="main"
                                >
                                  {/* <div class="aet-template " style="margin: 0 -12px;"> */}
                                  <div id="c-main-content" tabIndex={-1} />
                                  {/* <div class="container clearfix" style="padding:0px"> */}
                                  <div className="errorMessageBox hide">
                                    <span style={{ marginLeft: 20 }}>
                                      <img
                                        src="/aetna/aetna-press-center_files/red-error-icon.png"
                                        alt="rederror icon"
                                      />
                                    </span>
                                    <span className="errorMessageText">
                                      {" "}
                                      There is a system error message. An error
                                      has occurred while accessing your
                                      Communication Center.
                                    </span>
                                  </div>
                                  {/* 
				<div class="second-navigation ng-scope">
					<ul role="tablist" class="container clearfix">
						<li role="presentation" class="" ng-class="{active:screen==='message'}">
							<a role="tab" aria-selected="true" href="" ng-click="clickMessages()" class="ng-scope canbActiveMarker sec-level-nav canbLevel"
								data-toggle="tab" title="Messages" id="msgTab"> 
							<span ng-class="{linkActiveUnderline:screen==='message'}" class="" style="display: none;">Messages</span>
							</a>
						</li>
						<li role="presentation" class="" ng-class="{active:screen==='letters'}">
							<a role="tab" aria-selected="false" href="" class="ng-scope canbActiveMarker sec-level-nav canbLevel" ng-if="isLeComVisible" data-toggle="tab"
								title="Letter & Communication" ng-click="clickLettersCommunication()" id="letterTab"> 
							<span  ng-class="{linkActiveUnderline:screen==='letters'}" class="" 
								style="display: none;">Letters & Communications</span>
							</a>
						</li>
					</ul>
				</div>
				 */}
                                  <div className="forms-navigation ng-scope">
                                    {/* Added container class for story 707046	 */}
                                    <div
                                      className="clearfix container padL0"
                                      role="tablist"
                                    >
                                      <a
                                        ng-class="{'active messageLevel':screen==='message'}"
                                        role="tab"
                                        aria-selected="true"
                                        href=""
                                        ng-click="clickMessages()"
                                        className="ng-scope  canbActiveMarker sec-level-nav inline-block active messageLevel"
                                        data-toggle="tab"
                                        title="Messages"
                                        id="msgTab"
                                        style={{ display: "none" }}
                                      >
                                        Messages
                                      </a>
                                      {/**/}
                                      <a
                                        ng-class="{'active messageLevel':screen==='letters'}"
                                        role="tab"
                                        aria-selected="false"
                                        href=""
                                        className="ng-scope canbActiveMarker sec-level-nav inline-block"
                                        ng-if="isLeComVisible"
                                        data-toggle="tab"
                                        title="Letter & Communication"
                                        ng-click="clickLettersCommunication()"
                                        id="letterTab"
                                        style={{ display: "inline-block" }}
                                      >
                                        Letters &amp; Communications
                                      </a>
                                      {/**/}
                                      {/*<div class="tileBottom" ng-style="borderStyle"></div>*/}
                                      {/*<span class="arrowIndicator noTop" style="left: 440.5px;"></span>*/}
                                    </div>
                                  </div>
                                  <div
                                    className="modal fade contact-modal"
                                    id="contact-popup-msg"
                                    role="dialog"
                                    aria-labelledby="contact-confirmation"
                                  >
                                    <div className="modal-dialog">
                                      Modal content
                                      <div className="modal-content">
                                        {/* <div class="modal-header text-center">
								<h4 class="modal-title" id="contact-confirmation">{{popupTitle}}</h4>
							</div> */}
                                        <div className="modal-header">
                                          <button
                                            data-type="button"
                                            ng-click="popUpCloseMsgByOk()"
                                            className="close"
                                            data-dismiss="modal"
                                          >
                                            <img
                                              src="/aetna/aetna-press-center_files/close.png"
                                              className="close popup-close-btn"
                                              alt="Close"
                                            />
                                          </button>
                                          <span
                                            className="modal-title"
                                            id="contact-confirmation"
                                          >
                                            Alert
                                          </span>
                                        </div>
                                        <div
                                          className="modal-body"
                                          id="popUpBody"
                                        >
                                          <p
                                            ng-bind-html="popUpMessage"
                                            style={{
                                              overflowWrap: "break-word"
                                            }}
                                          >
                                            Upload failed. Please try again. If
                                            the issue persists, contact member
                                            services.
                                          </p>
                                        </div>
                                        <div className="text-center modal-body">
                                          <button
                                            data-type="submit"
                                            className="primaryBtn"
                                            ng-click="popUpCloseMsgByOk()"
                                          >
                                            Ok
                                          </button>
                                        </div>
                                        {/* <button data-type="button" class="close" data-dismiss="modal">
								<img src="/aetna/aetna-press-center_files/close.png" class="close" alt="Close" ng-click="popUpCloseMsgByOk()">
							</button> */}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="row"
                                    style={{ backgroundColor: "transparent" }}
                                  >
                                    <div className="col-xs-12" role="tabpanel">
                                      <div className="tab-content SSOLinkShow col-xs-12 marB15 pad0 marT15">
                                        {/**/}
                                        <div
                                          className="tab-pane fade in active"
                                          ng-class="{'in active':screen==='message'}"
                                          id="messages_mailbox"
                                          ng-if="screen === 'message'"
                                          style={{}}
                                        >
                                          {/* <span class="arrow-downView"
										style="Left: 20px; position: relative; width: 0; height: 0px; border-left: 12px solid transparent; border-right: 12px solid transparent; border-top: 12px solid #526f83; position: relative; top: 10px; left: 9%;"></span>
									 */}
                                          {/* NEW MESSAGE  */}
                                          {/**/}
                                          {/* end NEW MESSAGE */}
                                          {/* Changes done for new design */}
                                          {/**/}
                                       <MessageSection />
                                          {/**/}
                                        </div>
                                        {/**/}
                                      </div>
                                      {/* <h2 ng-if=IsTaxForm>If you have a need for a Digital Accessible version of the 1095-B form please call 855-531-6837</h2> */}
                                      <center>{/**/}</center>
                                      {/**/}
                                    </div>
                                  </div>
                                  <div className="fixedScroller">
                                    <a
                                      href=""
                                      className="mar0auto text-center pad15 opacity_layer upPointer"
                                    >
                                      <span className="pointer">
                                        <img
                                          src="/aetna/aetna-press-center_files/up_scroll_arrow.png"
                                          alt="Scroll up to top section of page"
                                        />
                                      </span>
                                    </a>
                                  </div>
                                  {/* <div scroll class="fixedScroller flotedScrollTop">
						<p id="upPoint" class="mar0auto text-center pad15 opacity_layer upPointer"
							ng-show="visible"
							ng-init="imgsrcup='/images/up_scroll_arrow.png'"
							ng-mouseover="imgsrcup='/images/up_scroll_arrow_Active.png'"
							ng-mouseout="imgsrcup='/images/up_scroll_arrow.png'">
							<span class="pointer"><img ng-src="{{imgsrcup}}" alt=""></span>
						</p>
						<p class="mar0auto text-center pad15 opacity_layer downPointer"
							ng-init="imgsrcdown='/images/down_scroll_arrow.png'"
							ng-mouseover="imgsrcdown='/images/down_scroll_arrow_Active.png'"
							ng-mouseout="imgsrcdown='/images/down_scroll_arrow.png'">
							<span class="pointer"><img ng-src="{{imgsrcdown}}" alt=""></span>
						</p>
					</div> */}
                                </section>
                              </div>{" "}
                              {/* end id="communicationCenterView" */}
                            </div>
                          </form>
                          {/* <div class="container footer-container-sm"> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    data-parent="page_286"
                    id="appid_299"
                    data-functionname="webApplicationContent"
                    parentdata-type="page"
                  >
                    {/**/}
                    <div
                      className="controller"
                      data-src="'components/messages/commCenterSSOLink.html?v=yhbqd'"
                      ng-include=""
                      style={{}}
                    >
                      <div
                        id="iFrameSMCSSODiv"
                        style={{ display: "none" }}
                        tabIndex={1}
                        ng-controller="commCenterSSOLinkController"
                      >
                        <div className="text-right cvsModalClose">
                          <button data-type="button" ng-click="closeSSOIframe()">
                            <img
                              src="/aetna/aetna-press-center_files/close.png"
                              className="close"
                              alt="Close"
                            />
                          </button>
                        </div>
                        <div className="col-md-12">
                          <iframe
                            name="iFrameSMCSSO"
                            className="col-md-12 pharmacy-row"
                            height="500vh"
                            frameBorder={0}
                            title="iFrameSMCSSO"
                            scrolling="auto"
                            width="100%"
                            iframe-onload="closeSpinner()"
                            allowFullScreen={false}
                          ></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/**/}
              {/**/}
              {/**/}
              {/**/}
            </div>
          </div>
        </div>
      </section>
    </div>
    {/**/}
    <div ui-view="footer">
      {/*Open Sans*/}
      {/*Adding bootstrap JS CDN for Carousel To be removed after testing*/}
      {/*  */}
      {/*Commenting as part of remediation for Navigator high login reponse time*/}
      {/*  */}
      {/* added for listening keepAlive messages from child iframes */}
      <div
        ng-show="footerCtrl.message.text"
        ng-bind="footerCtrl.message.text"
        className="ng-hide"
      />
      <footer id="aet-footer" className="aet-footer home-page-footer clearfix">
        <div
          data-parent="0-footer"
          id="footer_234"
          data-type="footer"
          className="container"
        >
          <ul
            data-parent="baselinks_237"
            id="rows_238"
            data-type="rows"
            parentdata-type="baselinks"
            className="aet-footer-nav clearfix"
          >
            <li className="">
              <a
                data-parent="leftjustified_239"
                id="link_240"
                parentdata-type="leftjustified"
                title="Terms of Use"
                href="https://www.aetna.com/legal-notices/disclaimer.html"
              >
                Terms of Use
              </a>
            </li>
            <li className="">
              <a
                data-parent="leftjustified_239"
                id="link_244"
                parentdata-type="leftjustified"
                title="Privacy Center"
                href="https://www.aetna.com/legal-notices/privacy.html"
              >
                Privacy Center
              </a>
            </li>
            <li className="">
              <a
                data-parent="leftjustified_239"
                id="link_248"
                parentdata-type="leftjustified"
                title="Plan Disclosures"
                href="https://www.aetna.com/individuals-families/member-rights-resources/rights/disclosure-information.html"
              >
                Plan Disclosures
              </a>
            </li>
            <li className="">
              <a
                data-parent="leftjustified_239"
                id="link_252"
                parentdata-type="leftjustified"
                title="Nondiscrimination Notice"
                href="https://www.aetna.com/legal-notices/nondiscrimination-notice.html"
              >
                Nondiscrimination Notice
              </a>
            </li>
            <li className="">
              <a
                data-parent="leftjustified_239"
                id="link_256"
                parentdata-type="leftjustified"
                title="Accessibility Services"
                href="#/contentPage?page=accessibilityServices"
              >
                Accessibility Services
              </a>
            </li>
            <li className="">
              <a
                data-parent="leftjustified_239"
                id="link_260"
                parentdata-type="leftjustified"
                title="En espanol"
                href="#/contentPage?page=espanolPage"
              >
                En español
              </a>
            </li>
            <li className="">
              <a
                data-parent="leftjustified_239"
                id="link_264"
                
                parentdata-type="leftjustified"
                title="Contact Us"
              >
                Contact Us
              </a>
            </li>
            <li className="">
              <a
                data-parent="leftjustified_239"
                id="link_269"
                parentdata-type="leftjustified"
                title="Contactenos"
                href="#/contentPage?page=spanishContactUs"
              >
                Contáctenos
              </a>
            </li>
          </ul>
          <div
            data-parent="footer_234"
            id="footerbottomchrome_274"
            data-type="footerbottomchrome"
            parentdata-type="footer"
            className="aet-footer-logo clearfix"
          >
            <div
              data-parent="leftjustified_275"
              id="appid_276"
              data-functionname="autoCopyright"
              parentdata-type="leftjustified"
              className="aet-copyrights"
            >
              Copyright © 2001-2023 Aetna Inc.
            </div>
            <div
              data-parent="footerbottomchrome_274"
              id="rightjustified_279"
              data-type="rightjustified"
              parentdata-type="footerbottomchrome"
              className="pull-right noPull"
            >
              <a href="https://seal.digicert.com/seals/popup/?tag=WfXznSFa&url=member.aetna.com&cbr=1484319282915">
                <img
                  data-parent="rightjustified_279"
                  id="image_280"
                  parentdata-type="rightjustified"
                  data-nvstyle="digicertLink"
                  src="https://member.aetna.com/secure/member/images/digicert.png?v=yhbqd"
                  alt="secure image"
                />
              </a>
              <div
                data-parent="rightjustified_279"
                id="appid_283"
                data-functionname="webApplicationContent"
                parentdata-type="rightjustified"
              >
                {/**/}
                <div
                  className="controller"
                  data-data-src="'components/footer/footerLangAssistant.html?v=yhbqd'"
                  ng-include=""
                  style={{}}
                >
                  <div
                    className="aet-footer-logo align-lang-assist clearfix"
                    ng-controller="footerLangAssistantController"
                  >
                    <div
                      className="footer-langAssistant"
                      id="alignLangAssistantLink"
                    >
                      <img src="/aetna/aetna-press-center_files/globe.png" alt="" />
                      <span
                        id="langAssistantLink"
                        title="Language Assistance"
                        style={{ color: "#7d3f98" }}
                      >
                        Language Assistance:{" "}
                      </span>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Spanish"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="es">Español |</span>
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Chinese"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="zh-Hant">中文</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Vietnamese"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="vi">Tiếng Việt</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Korean"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="ko">한국어</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Tagalog"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="tl">Tagalog</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Russian"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="ru">Русский</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Arabic"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="ar">العربية</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#French Creole"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="ht">Kreyòl</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#French"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="fr">Français</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Polish"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="pl">Polski</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Portuguese"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="pt">Português</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Italian"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="it">Italiano</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#German"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="de">Deutsch</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Japanese"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="ja">日本語</span> |
                      </a>
                      <a
                        href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html#Persian"
                        data-analytics-name="Español"
                        data-linklocation="footer"
                        className=""
                      >
                        <span lang="fa">فارسی</span> |
                      </a>
                      <a href="https://www.aetna.com/individuals-families/contact-aetna/member-information-in-other-languages.html">
                        <wbr/>Other Languages…
                      </a>
                    </div>
                    {/* Added iframe for brighter keepalive */}
                    <iframe
                      id="logoutBrighterIframe"
                      style={{ visibility: "hidden" }}
                      src=""
                      width={0}
                      height={0}
                      title="logoutBrighterIframe"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>


    )

}

const MessageSection = (props:{
  
}) => {
  const [dcViewer, setDcViewer] = React.useState<any>(null);
  React.useEffect(() => {

    document.addEventListener('exhibit-e-pdf', (e:any) => {
      setDcViewer((window as any)['exhibit-e-pdf']);

      console.log('setDcViewer')

    });

  }, []);
    return(
        <div id="message-section" ng-if="!showNewMessage">
  <div className="mailCenter row">
    <div className="col-xs-12">
      <div className="thirdLevel-navigation ng-scope">
        <div
          className="container clearfix col-xs-9 padR0 marT15"
          role="tablist"
        >
          {/**/}
          <a
            ng-class="{'active' : msgSelname==='inbox'}"
            role="tab"
      
            ng-click="clickInbox()"
            className="ng-scope canbActiveMarker sec-level-nav inline-block"
            data-toggle="tab"
            title="Messages"
            id="inbxTab"
            ng-if="isLeComVisible"
            style={{}}
          >
            Inbox
          </a>
          {/**/}
          {/**/}
          <a
            ng-class="{'active' : msgSelname==='sent'}"
            role="tab"
            aria-selected="true"
            href=""
            className="ng-scope canbActiveMarker sec-level-nav inline-block messageLevel active"
            data-toggle="tab"
            title="Sent"
            ng-click="clickSentItems()"
            id="sntTab"
            ng-if="isLeComVisible"
            style={{}}
          >
            Sent
          </a>
          {/**/}
          {/**/}
          <a
            ng-class="{'active' : msgSelname==='archive'}"
            role="tab"
            aria-selected="false"
            rel="nofollow"
            href=""
            className="ng-scope canbActiveMarker sec-level-nav inline-block"
            data-toggle="tab"
            title="Sent"
            ng-click="clickArchivedMessages()"
            id="archvdTab"
            ng-if="isLeComVisible"
          >
            Archived
          </a>
          {/**/}
        </div>
      </div>
      {/**/}
      <div
        className="col-xs-3 PadL0 text-right mailBoxHandlerHederActionsButtons"
        ng-if="!suppressNewMessageFeature"
      >
        <a
          aria-labelledby="NewMsg"
          ng-show="showNewMessageButton"
          ng-click="clickedNewMessage();"
          href=""
          className="main_newMessage"
        >
          <span id="NewMsg" className="hidden-xs hidden-sm">
            New Message
          </span>
        </a>
      </div>
      {/**/}
      {/* <div class="col-xs-9 padR0">
												<ul role="tablist" class=" pad15 nav-tabs">
													<li  role="presentation" ng-class="{active:msgSelname==='inbox'}"><a role="tab" aria-selected="true"
														href="" data-toggle="tab" class="mail_inbox"
														ng-click="clickInbox()" ng-class="{linkActiveUnderline:msgSelname==='inbox'}" id="inbxTab">Inbox</a></li>
													<li  role="presentation" ng-class="{active:msgSelname==='sent'}"><a role="tab" aria-selected="false" href=""
														ng-click="clickSentItems()" data-toggle="tab"
														class="mail_sent" ng-class="{linkActiveUnderline:msgSelname==='sent'}" id="sntTab">Sent</a></li>
													<li  role="presentation" ng-class="{active:msgSelname==='archive'}"><a role="tab" aria-selected="false"
														href="" data-toggle="tab" class="mail_archived"
														ng-click="clickArchivedMessages()" ng-class="{linkActiveUnderline:msgSelname==='archive'}" id="archvdTab">Archived</a></li>

												</ul>
											</div> */}
    </div>
  </div>
  <div className="tab-content mailBox" role="tabpanel">
    <div id="secureInbox" className="tab-pane fade in active">
      {/* alerts start */}
      {/**/}
      {/* alerts end */}
      {/* Inbox messages start */}
      {/**/}
      {/* Inbox messages end */}
      <div id="secureInbox" className="tab-pane fade in active">
        <div className="mailHeader row">{/**/}</div>
      </div>
    </div>
    {/*Inbox end*/}
    {/* Archvied start */}
    {/**/}
    {/* Archived end */}
    {/* sent messages start */}
    {/**/}
    <div
      id="secureSent"
      className="tab-pane fade in active"
      ng-class="{'in active':msgSelname==='sent'}"
      ng-if="msgSelname ==='sent'"
      style={{}}
    >
      <div id="noSendMsg" className="tab-pane fade in active">
        <div className="mailHeader row">{/**/}</div>
      </div>
      {/**/}
<SecureMessagesMapStyle />


      {/**/}
    </div>
    {/**/}
    {/*  sent messages end */}
    {/*  message center bottom section start */}
    <div>
      <div>
        <div className="col-xs-12 pull-right pad15 marL5 unreadMails">
          <div
            ng-class="((msgSelname ==='inbox') || (msgSelname ==='archive'))?'col-xs-12 text-right':'col-xs-12 text-right'"
            className="col-xs-12 text-right"
          >
            {/**/}
            {/**/}
            <p
              ng-if="((msgSelname==='sent') || (msgSelname==='archive'))"
              className=""
              style={{}}
            >
              Messages will be removed after 24 months.
            </p>
            {/**/}
          </div>
        </div>
        {/**/}
      </div>
      <div className="col-xs-12 show-alerts border-top mrgnT20">
        <div className="checkboxbg clearfix" style={{ marginBottom: 15 }}>
          <label className="clearfix" htmlFor="phone_select">
            <span
              id="phone_Check"
              data-value="select_check"
              data-name="phone_select"
              ng-class="{'chkLabelCheck':select , 'unchkLabelCheck': !select}"
              className="chkLabelCheck"
              ng-click="showAlertOnLogin()"
              style={{}}
            />
            <span className="padL10">
            <img
                          style={{
                            opacity:0.7
                          }}
                          src='https://www.resourcesforliving.com/media/images/Header_Logos/Custom_Logos/Amazon.jpg' alt='Amazon Logo' />
            </span>
          </label>
          <input
            type="checkbox"
            id="phoneSelect"
            className="checkbox ng-pristine ng-untouched ng-valid ng-not-empty"
            ng-model="select"
            style={{}}
          />
        </div>
      </div>
    </div>
    {/*  message center bottom section end */}
  </div>
</div>

    )
}

export default Root;